<template>
  <div class="modal micromodal-slide" :class="{'is-open': isOpen}">
    <div class="modal__overlay"></div>
    <div class="modal_item error_detail">
      <button @click="close" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <div id="js-error_wrap" class="error_wrap">
        <div v-if="message != ''">
          <p class="error_text ab" v-html="message">{{ message }}</p>
        </div>
      </div>
      <div id="js-btn_wrap" class="btn_wrap">
        <button @click="close" class="ok_btn ab">いいえ</button>
        <button @click="closeTransition" class="ok_btn ab">はい</button>
      </div>

    </div>
  </div>
</template>

<script>
import scrollPosition from '@/model/scrollPosition';

export default {
  props: ['message'],
  data() {
    return {
      // message: '',
      isOpen: true,
    }
  },
  methods: {
    close () {
      scrollPosition.close();
      // this.isOpen = false;
      this.$emit('modalClose');
    },
    closeTransition() {
      scrollPosition.close();
      this.$emit('modalCloseTransition');
    },
    open() {
      scrollPosition.open();
      this.isOpen = true;
    }
  },
  watch: {
    // errorMessage() {
    //   this.message = errorMessage;
    // }
  }
}
</script>

<style lang="css" scoped>
.error_detail {
  border-radius: 12px;
  height: 240px;
  margin: auto;
  overflow: hidden;
  right: 0;
  top: 0;
  width: 91%;
}
.error_wrap {
  padding: 60px 16px 16px;
  text-align: center;
}
.modal_item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
}
.btn_wrap {
   display: flex;
}
.ok_btn {
  background-color: transparent;
  border: none;
  border-top: 2px solid  #ccc;
  font-size: 16px;
  line-height: 1;
  padding: 20px;
  width: 100%;
}
.ok_btn:last-child {
  border-left: 2px solid  #ccc;
}
/* .error_text {
  color: red;
} */
>>> .small {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DialogModal.vue